// extracted by mini-css-extract-plugin
module.exports = {"appIcon":"SettingsIntegrationIcon_appIcon__KRGgL"};